module.exports = __webpack_public_path__ + "img/full-img3.a2d07d4c.png";